import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import * as _moment from 'moment';

import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';

// core components
// import {
//   chartOptions,
//   parseOptions,
//   chartExample1,
//   chartExample5,
//   chartExample6,
//   chartExample7
// } from "../../variables/charts";
import { NavigationStart, Router } from '@angular/router';
import * as M from "materialize-css/dist/js/materialize";
//import { AntEnvService } from 'src/app/_services/ant.env.svc';
// import { DataService } from 'src/app/_services/data.service';
import { Chart, registerables } from 'chart.js';
import { AntEnvService, AuthService, DataService, HelperService } from '../../_services';
import { forkJoin, Observable } from 'rxjs';
import * as saveAs from 'file-saver';
import { DateTimeAdapter } from 'ng-pick-datetime';

@Component({
  selector: 'app-dashboardV02AD',
  templateUrl: './dashboardV02AD.component.html',
  styleUrls: ['./dashboardV02AD.component.scss']
})
export class DashboardV02ADComponent implements OnInit {
  @ViewChild('chtOrders', {read:null, static:false}) chtOrders: ElementRef;
  @ViewChild('chtDt', {read:null, static:false}) chtDt: ElementRef;
  @ViewChild('chtTe', {read:null, static:false}) chtTe: ElementRef;
  @ViewChild('pdfTable') pdfTable!: ElementRef;

  public datasets: any;
  public data: any; dataLevel4 = []; exportData = []; hisDataLevel = [];
  public clicked: boolean = true;
  public clicked1: boolean = false;
  public selectedMoment = [new Date(), new Date()] //'Sat Dec 18 2021 00:00:00 GMT+0630 (Myanmar Time)';//new Date();
  private date = new Date();
  public compareSelectedMoment = [];
  public arrHr: any = [];

  constructor(
    private ngZone: NgZone,
    private svcAntEnv: AntEnvService,
    private svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router
  ){ 
    this.date.setDate(this.date.getDate() - 7);
    this.compareSelectedMoment = [this.date, this.date];
    //dateTimeAdapter.setLocale('en-IN');
    Chart.register(...registerables);
   }

  
  client = '';
  pageData = {
    account: {
      //fullName: '', email: '', password: '', confirmPassword: '', contactNo: '', imageUrl: '', role: 'ADMIN', title: ''
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [], areas:[], areas4Occupancy:[],
    areaIndex: -1, inValue: 0, outValue: 0, occupancyValue: 0,
    data: [], hourlyDtd:[],
    cDataEntry: [], cDataExit: [], cDataOccupancy: [], cHourlyDTD: [], cTopSensorData: [], cSensorUuid: [],
    cDTRangeData: [],
    cHisEntry:[], cHisExit: [], cHisOccupancy: [], cHisTopSensorData: [], cHisDTRangeData: [],
    autoRefresh: false, isToday: false, maxOccupancy: 0
  }

  dailyLabels: any = [];
  dailyCounts: any = [];
  hisDailyLabels: any = [];
  hisDailyCounts: any = [];

  formats = [
    {title: 'Hourly', value: 'HOURLY'},
    {title: 'Daily', value: 'DAILY'},
    {title: 'Weekly', value: 'WEEKLY'},
    {title: 'Monthly', value: 'MONTHLY'}
  ];
  formatSelected: any = {title: 'Daily', value: 'DAILY'};

  dataHis = {
    data: [], peakHourTitle: '-',
    inValue: 0, outValue: 0, maxOccupancy: 0
  };

  isLoading = true;
  isLoadingOccupancy = false;
  area:any;
  chtEntry:any;
  chtExit:any;
  chtOccupancy:any;
  chtHourlyDwellTime:any;
  peakHourTitle = '-';
  dwelltimeMinute = 0;
  dwelltimeMinuteLastWeek = 0;
  isShowDTD = false;
  his: Array<number>;
  ordersChart: any;
  salesChart: any;
  teChart: any;
  dtChart: any;
  lDate: any = [];
  compareDate: any = [];
  _hisAreaDetail: any = [];

  
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }

  ngOnInit() {

    this.svcAntEnv.load().subscribe(res=>{
      if(res.client != null){
          this.client = res.client;
      }
    });

    if(this.svcData.dsDateParam.length != 0){
      this.selectedMoment = this.svcData.dsDateParam;
      this.svcData.dsDateParam = [];
      //console.log(this.svcData.dsDateParam);
    }

    if(this.svcData.dsCompareDateParam.length != 0){
      this.compareSelectedMoment = this.svcData.dsCompareDateParam;
      this.svcData.dsCompareDateParam = [];
      //console.log(this.svcData.dsCompareDateParam);
    }

    this.areaListLoad();

    

    this.datasets = [
      [0, 20, 10, 30, 15, 40, 20, 60, 60],
      [0, 20, 5, 25, 10, 30, 15, 40, 40]
    ];
    this.data = this.datasets[0];
    this.dataLevel4 = [];
    this.hisDataLevel = [];
    this.exportData = [];
    
    ////var chartOrders = document.getElementById('chart-orders');

    // parseOptions(Chart, chartOptions());



    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 500);

  }

  formatSelect(arg){
    this.formatSelected = arg;  
    this.svcData.dsDateParam = this.selectedMoment;
    this.svcData.dsCompareDateParam = this.compareSelectedMoment;
    if(arg.title == "Hourly"){
      this.router.navigate(['/dashboardV02A'])
    }
    if(arg.title == "Daily"){
      this.router.navigate(['/dashboardV02AD'])
    }
    if(arg.title == "Weekly"){
      this.router.navigate(['/dashboardV02AW'])
    }
    if(arg.title == "Monthly"){
      this.router.navigate(['/dashboardV02AM'])
    }
  }

  public downloadAsPDF(chtName:string) {
    const canvas = <HTMLCanvasElement> document.getElementById(chtName);
    const tblSkill = document.getElementById('pdf'+chtName);
    const canvasImage = canvas.toDataURL('image/jpeg', 1.0);
    
    let pdf = new jsPDF('landscape');
    pdf.setFontSize(12);
    pdf.setDrawColor(204, 204,204,0);
    //pdf.rect(10, 10, 150, 160, "F");
    //console.log(canvas.width);
    pdf.addImage(canvasImage, 'png', 5, 5, tblSkill.clientWidth*0.15, canvas.height*0.2);
    pdf.save(chtName+'.pdf');      
  }

  downloadTblAsPDF() {
    const pdfTable = this.pdfTable.nativeElement;
    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download(); 
     
  }

  dateChange(args){
    this.svcData.dsDateParam = args;
    this.dataLoad();
  }
  compareDateChange(args){
    this.svcData.dsCompareDateParam = args;
    this.dataLoad();
  }

  chartIntervals(openingTime, closingTime){
    var _arrHr = [];
    var _startHour = _moment(openingTime).hour();
    var _endHour = _moment(closingTime).hour();
    if(_endHour==0) _endHour = 23;
    for(var i=_startHour;i<=_endHour;i++){
      _arrHr.push(i + ':00');
    }
    return _arrHr;
  }

  areaListLoad(){
    this.svcData.areaListForDashboard().subscribe(res=>{
      if(res.status != 'OK'){
        //this.showAlert(res.message);
        return;
      }
      this.pageData.areas = res.data;
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
      setTimeout(function(){
        M.FormSelect.init(document.querySelectorAll('select'), {classes:'ddl-001'});
      }, 3000);
    });
  }

  dataLoad(){
    this.loading(true);
    this.svcData.areaDetail(this.area.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        //this.showAlert(res.message);
        return;
      }
      var _areaDetail = res.data;
      this._hisAreaDetail = res.data;
      var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss'); //'20211118090000'; //_moment(this.selectedMoment).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss'); //'20211218225900';//_moment(this.selectedMoment).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
      
      var _hisStartTime = _moment(this.compareSelectedMoment[0]).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss'); //'20211111090000'; //_moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      var _hisEndTime = _moment(this.compareSelectedMoment[1]).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss'); //'20211211225900'; //_moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
      
      this.pageData.isToday = _startTime == _moment().format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      this.pageData.maxOccupancy = 0;
      var _startTimeLastWeek = _moment(this.selectedMoment[0]).subtract(7,'d').format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
      
      this.arrHr = this.chartIntervals(this.area.openingTime, this.area.closingTime);
      var _mxoccupancy = 0;

      
      this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          console.log('sensor data error### ' + this.area.areaId);
          //this.showAlert(res.message);
          return;
        }
        // console.log(res);
        this.pageData.inValue = 0;
        this.pageData.outValue = 0;
        this.pageData.maxOccupancy = 0;
        this.pageData.data = res.data;
        _mxoccupancy = 0;
  
        this.pageData.cDataEntry = [];
        this.pageData.cDataExit = [];
        this.pageData.cDataOccupancy = [];
        this.dailyCounts = [];
        this.dailyLabels = [];
        this.dataLevel4 = [];
        this.exportData = [];
  
        // var cIntervals = this.chartIntervals(this.area.openingTime, this.area.closingTime);
        var cHour = _moment().hour();
        
        
        var _openingHour = _moment(this.area.openingTime).hour();

        if(this.pageData.data.length != 0){
        var tstmp = this.pageData.data[0].timestamp;
        var indx = 0;
        this.dailyLabels[indx] = this.pageData.data[0].timestamp;
        this.dailyCounts[indx] = 0; //this.pageData.data[0].inValue;
        //console.log(this.pageData.data);
        //console.log(_openingHour);
        this.pageData.data.forEach((x, i)=>{
          if(_moment(x.timestamp).hour() >= _openingHour && _moment(x.timestamp).hour() <= _moment(this.area.closingTime).hour()){
            if(_moment(x.timestamp).format('YYYYMMDD') == _moment(tstmp).format('YYYYMMDD')){
              this.dailyLabels[indx] = _moment(x.timestamp).format('DD MMM YYYY');
              this.dailyCounts[indx] += x.inValue;
              this.pageData.cDataExit[indx] += x.outValue;            
            }
            else{
              tstmp = x.timestamp;
              indx ++;
              this.dailyLabels.push(_moment(x.timestamp).format('DD MMM YYYY'));
              this.dailyCounts.push(x.inValue);
            }
            this.pageData.inValue +=  x.inValue;
            this.pageData.outValue += x.outValue;
            
            //if(indx < 7)
            this.dataLevel4[indx] = {d:this.dailyLabels[indx], t:this.dailyCounts[indx], o:0, hd:'', ht:0, ho:0};
            this.exportData[indx] = {d:this.dailyLabels[indx], t:this.dailyCounts[indx], o:0, hd:'', ht:0, ho:0};

            _mxoccupancy += x.inValue - x.outValue;
            if(_mxoccupancy<0) _mxoccupancy = 0;
            if(_mxoccupancy>this.pageData.maxOccupancy) this.pageData.maxOccupancy = _mxoccupancy;
            
            var iHour = _moment(x.timestamp).hour()-_openingHour;
            
            
            if(this.pageData.isToday && iHour>cHour){
              this.pageData.cDataEntry[iHour] = null;
              this.pageData.cDataExit[iHour] = null;
            }
            else{
              this.pageData.cDataEntry[iHour] = x.inValue;
              this.pageData.cDataExit[iHour] = x.outValue;
            }
          }
        });
      }

        if(this.pageData.inValue<this.pageData.outValue){
          this.pageData.outValue = this.pageData.inValue;
        }
        
        //if(this.pageData.maxOccupancy<0) this.pageData.maxOccupancy = 0;
        //this.pageData.cDataEntry = this.dailyCounts;
        var _occupancy = 0;
        //console.log(this.dataLevel4[0]);
        // this.chartOrdersBind();
        //console.log(this.pageData.cDataEntry);
        this.pageData.cDataEntry.forEach((x, iX)=>{
          if(x==null && this.pageData.cDataExit[iX]==null) return;
          _occupancy += x - this.pageData.cDataExit[iX];
          if(_occupancy<0) _occupancy = 0;
          if(this.pageData.isToday && cHour<iX) _occupancy = null;
          this.pageData.cDataOccupancy[iX] = _occupancy;
          //if(iX < 7)this.dataLevel4[iX].o = _occupancy;
          //this.exportData[iX].o = _occupancy;
          //if(_occupancy>this.pageData.maxOccupancy) this.pageData.maxOccupancy = _occupancy;
        })
        this.chartOrdersBind(this.dataLevel4);
        //this.chartSalesBind();
        
        if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;
  
        this.dataLoadHistory(_areaDetail);
        //this.loadHourlyDwellTimeData(_startTime, _endTime, this.area.areaId);
        this.dataLoadPeakHour();
          // this.loadDwellTimeData(_startTime);
          // this.loadDwellTimeDataLastWeek(_startTimeLastWeek);

        
        //this.loadHourlyRangeDwellTimeData(this.area.areaId, _startTime, _endTime, _hisStartTime, _hisEndTime);

        this.loadTopSensorData(this.area.areaId, _startTime, _endTime, _hisStartTime, _hisEndTime);

        if(!this.pageData.isToday){
          this.pageData.outValue = this.pageData.inValue;
          this.pageData.occupancyValue = 0;
        }
      });
      if(this.pageData.isToday){
        this.dataLoad4Occupancy();
      }
      else{
        this.pageData.areas4Occupancy = [];
      }
    });
  }

  areaSelect(arg){
    this.area = arg;
    this.dataLoad();
  }

  areaSelectDdl(arg){
    //console.log(arg);
    var _arr = this.pageData.areas.filter(x=>x.areaName == arg);
    if(_arr.length<1){
      alert('Area not found ' + arg);
      return;
    }
    this.areaSelect(_arr[0]);
  }

  dataLoadHistory(_areaDetail){
    var _startTime = _moment(this.compareSelectedMoment[0]).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss'); //'20211111090000' //_moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.openingTime).format('HHmmss');
    var _endTime = _moment(this.compareSelectedMoment[1]).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss'); //'20211211225900'; //_moment(this.selectedMoment).add('day', -7).format('YYYYMMDD') + _moment(_areaDetail.closingTime).format('HHmmss');
    this.dataHis.inValue = 0;
    this.dataHis.outValue = 0;
    this.dataHis.maxOccupancy = 0;
    this.dataHis.peakHourTitle = '-';
    var _maxIn = 0;
    var _occupancy = 0;
    this.pageData.cHisEntry = [];
    this.hisDataLevel = [];
    this.pageData.cHisExit = [];
    this.pageData.cHisOccupancy = [];

    
    this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
      this.hisDailyCounts = [];
      this.hisDataLevel = [];
      _occupancy = 0;
      this.dataHis.maxOccupancy = 0;
      if(res.data.length == 0 || res.status != 'OK'){
        //this.showAlert(res.message);
        this.chartOrdersBind(this.dataLevel4);
        //console.log(this.hisDailyCounts);
        return;
      }
      // console.log('not 0 or OK');
      this.dataHis.data = res.data;

      var tstmp = this.dataHis.data[0].timestamp;
      var indx = 0;
      this.hisDailyLabels[indx] = this.dataHis.data[0].timestamp;
      // this.hisDailyCounts[indx] = this.dataHis.data[0].timestamp.toString();//added
      this.hisDailyCounts[indx] = 0;
      this.hisDataLevel = [{d:'', t:0}];

      var _openingHour = _moment(this.area.openingTime).hour();

      this.dataHis.data.forEach(d=>{
        if(_moment(d.timestamp).hour() >= _openingHour && _moment(d.timestamp).hour() <= _moment(this.area.closingTime).hour()){
        this.dataHis.inValue += d.inValue;
        this.dataHis.outValue += d.outValue;

        if(_moment(d.timestamp).format('YYYYMMDD') == _moment(tstmp).format('YYYYMMDD')){
          this.hisDailyLabels[indx] = _moment(d.timestamp).format('DD MMM YYYY').toString()+" - ";
          this.hisDailyCounts[indx] += d.inValue;
          this.hisDataLevel[indx].d = _moment(d.timestamp).format('DD MMM YYYY').toString();
          this.hisDataLevel[indx].t += d.inValue;
          this.pageData.cDataExit[indx] += d.outValue;
        }
        else{
          tstmp = d.timestamp;
          indx ++;
          this.hisDailyLabels.push(_moment(d.timestamp).format('DD MMM YYYY')).toString()+" - ";
          //this.hisDailyCounts.push(d.inValue);
          this.hisDailyCounts.push(d.inValue);
          this.hisDataLevel.push({d:_moment(d.timestamp).format('DD MMM YYYY').toString(), t:d.inValue})
        }

        if(d.inValue > _maxIn){
          _maxIn = d.inValue;
          this.dataHis.peakHourTitle = _moment(d.timestamp).format('hh A');
        }
        _occupancy += d.inValue - d.outValue;
        if(_occupancy<0) _occupancy = 0;
        if(_occupancy>this.dataHis.maxOccupancy) this.dataHis.maxOccupancy = _occupancy;

        // this.pageData.cHisEntry.push(d.inValue);
        // this.pageData.cHisExit.push(d.outValue);
        // this.pageData.cHisOccupancy.push(_occupancy); 
      }
      });

      if(this.dataHis.inValue<this.dataHis.outValue){
        this.dataHis.outValue = this.dataHis.inValue;
      }

      if(this.hisDataLevel != null){
        this.hisDataLevel.forEach((hd,iX) => {
          if(iX < this.dataLevel4.length && this.dataLevel4.length != 0){
            this.dataLevel4[iX].hd = hd.d;
            this.dataLevel4[iX].ht = hd.t;
            this.exportData[iX].hd = hd.d;
            this.exportData[iX].ht = hd.t;
          }
        })
      }
      
        this.chartOrdersBind(this.dataLevel4);
    });    
  }

  dataLoadPeakHour(){
    this.peakHourTitle = '-';
    var _maxIn = 0;
    this.pageData.data.forEach(d=>{
      if(d.inValue > _maxIn){
        _maxIn = d.inValue;
        this.peakHourTitle = _moment(d.timestamp).format('hh A');
      }
    });
  }

  loadHourlyDwellTimeData(startTime, endTime, areaId){
    this.svcData.hourlyDwellTimeData(startTime, endTime, areaId).subscribe(hdw=>{
      this.pageData.hourlyDtd = hdw.data;
      this.pageData.hourlyDtd.forEach(x=>{
        this.pageData.cHourlyDTD.push(x.dwellTimeMinute/60);
      })
    });
  }

  loadDwellTimeData(startTime: any){
    this.svcData.getDwellTimeData(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        //this.showAlert(dw.message);
        return;
      }      
      // else{
      // this.svcData.isShowDTD(this.area.areaId).subscribe(res => {
      //   if(dw.status != 'OK'){
      //     //this.showAlert(res.message);
      //     return;
      //   }      
      //   else{
      //   this.isShowDTD = res.data[0].value == 1 ? true : false;
      //   }
      // });
        if(dw.data.length>0){
          this.dwelltimeMinute = dw.data[0].dwellTimeMinute;
        }
      //}
      
    })
  }

  loadDwellTimeDataLastWeek(startTime: any){
    this.svcData.getDwellTimeDataLastWeek(startTime).subscribe(dw=> {
      if(dw.status != 'OK'){
        //this.showAlert(dw.message);
        return;
      }   
      if(dw.data.length>0){   
      this.dwelltimeMinuteLastWeek = dw.data[0].dwellTimeMinute;
      }
    })
  }

  dataLoad4Occupancy(){
    this.pageData.areas4Occupancy = [];
    this.svcData.areaListForOccupancy().subscribe(res=>{
      if(res.status != 'OK'){
        //this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;

      var _arrReq:Observable<any>[] = [];
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD') + _moment(rec.openingTime).format('HHmmss');
        var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD') + _moment(rec.closingTime).format('HHmmss');
        _arrReq.push(this.svcData.sensorData(rec.areaId, _startTime, _endTime));
      });
      this.isLoadingOccupancy = true;
      forkJoin(_arrReq).subscribe(resArr=>{
        this.isLoadingOccupancy = false;
        resArr.forEach((resOccupancy, i)=>{
          if(resOccupancy.status != 'OK'){
            //this.showAlert(resOccupancy.message);
            return;
          }
          var _areaOccupancy = 0;
          var _dataOccupancy = resOccupancy.data;

          this.pageData.areas4Occupancy[i].inTotal = 0;
          this.pageData.areas4Occupancy[i].outTotal = 0;
          _dataOccupancy.forEach(x=>{
            _areaOccupancy += x.inValue - x.outValue;
            this.pageData.areas4Occupancy[i].inTotal += x.inValue;
            this.pageData.areas4Occupancy[i].outTotal += x.outValue;
            if(_areaOccupancy<0) _areaOccupancy = 0;
          });
          this.pageData.areas4Occupancy[i].occupancy = _areaOccupancy;
          this.pageData.areas4Occupancy[i].occupancyTitle = _areaOccupancy;
        });
        if(this.client == 'DM'){
          if(this.pageData.areas4Occupancy[0].occupancy<=0 && this.pageData.areas4Occupancy[0].inTotal>0){
            this.pageData.areas4Occupancy[0].occupancy = Math.round(this.pageData.areas4Occupancy[0].inTotal*0.01);
            this.pageData.areas4Occupancy[0].occupancyTitle = this.pageData.areas4Occupancy[0].occupancy;
          }
        }
        else if(this.client == 'TB'){
          var _occBD = this.pageData.areas4Occupancy[0].occupancy;
          var _occ1 = this.pageData.areas4Occupancy[1].occupancy; // MH
          var _occ2 = this.pageData.areas4Occupancy[2].occupancy; // R
          var _occ3 = this.pageData.areas4Occupancy[3].occupancy; // SR
          this.pageData.areas4Occupancy[0].occupancy = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[0].occupancyTitle = _occ1+_occ2+_occ3;
          this.pageData.areas4Occupancy[1].occupancyTitle = _occ1;
          this.pageData.areas4Occupancy[2].occupancyTitle = _occ2;
          this.pageData.areas4Occupancy[3].occupancyTitle = _occ3;
          console.log('occupancy TB loaded>>>>', this.pageData.areas4Occupancy[0]);
        }
      })
    });
  }

  

  loadTopSensorData(areaId: any, startTime: any, endTime: any,_hisStartTime: any, _hisEndTime: any){
    this.pageData.cTopSensorData = [];
    this.pageData.cSensorUuid = [];
    this.svcData.getTopSensorData(areaId,startTime, endTime).subscribe(res=>{
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        // console.log(res.data);
        this.pageData.cTopSensorData = [];
        this.pageData.cSensorUuid = [];
        res.data.forEach(x => {
          this.pageData.cTopSensorData.push(x.inValue);
          this.pageData.cSensorUuid.push(x.sensor.sensorUuid).toString();
        });
        this.loadHisTopSensorData(this.pageData.cTopSensorData, areaId,startTime, endTime, _hisStartTime, _hisEndTime);
      }
    })
  }

  loadHisTopSensorData(cTopSensorData: any, areaId: any, startTime: any, endTime: any, hisStartTime: any, hisEndTime: any){
    this.pageData.cHisTopSensorData = [];
    this.svcData.getHisTopSensorData(areaId,startTime, endTime, hisStartTime, hisEndTime).subscribe(res=>{
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        res.data.forEach(x => {
          this.pageData.cHisTopSensorData.push(x.inValue);
        });
      }
      this.chartTopEntrancesBind(cTopSensorData);
    })
  }

  loadHourlyRangeDwellTimeData(areaId: any, startTime: any, endTime: any, hisStartTime: any, hisEndTime: any){
    var _3to5personCount = 0, _5to10personCount = 0, _10to20personCount = 0, _20to30personCount = 0, _30pluspersonCount = 0;
    this.svcData.getHourlyRangeDwellTimeList(areaId,startTime, endTime).subscribe(res=>{
      if(res != null){
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        res.data.forEach(a => {
          if(a.dwellTimeMinutes.totalMinutes >= 3 && a.dwellTimeMinutes.totalMinutes <= 5){
            _3to5personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 5 && a.dwellTimeMinutes.totalMinutes <= 10){
            _5to10personCount += a.personCount;
          } 
          if(a.dwellTimeMinutes.totalMinutes >= 10 && a.dwellTimeMinutes.totalMinutes <= 20){
            _10to20personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 20 && a.dwellTimeMinutes.totalMinutes <= 30){
            _20to30personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes > 30){
            _30pluspersonCount += a.personCount;
          }         
        });
        this.pageData.cDTRangeData.push(_3to5personCount);
        this.pageData.cDTRangeData.push(_5to10personCount);
        this.pageData.cDTRangeData.push(_10to20personCount);
        this.pageData.cDTRangeData.push(_20to30personCount);
        this.pageData.cDTRangeData.push(_30pluspersonCount);

        this.loadHisHourlyRangeDwellTimeData(areaId, hisStartTime, hisEndTime);
        //this.chartDwellTimeBind();

      }
    }
    })
  }

  loadHisHourlyRangeDwellTimeData(areaId: any, startTime: any, endTime: any){
    var _3to5personCount = 0, _5to10personCount = 0, _10to20personCount = 0, _20to30personCount = 0, _30pluspersonCount = 0;
    this.svcData.getHourlyRangeDwellTimeList(areaId,startTime, endTime).subscribe(res=>{
      if(res != null){
      if(res.status != 'OK'){
        return;
      }
      if(res.data.length>0){
        res.data.forEach(a => {
          if(a.dwellTimeMinutes.totalMinutes >= 3 && a.dwellTimeMinutes.totalMinutes <= 5){
            _3to5personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 5 && a.dwellTimeMinutes.totalMinutes <= 10){
            _5to10personCount += a.personCount;
          } 
          if(a.dwellTimeMinutes.totalMinutes >= 10 && a.dwellTimeMinutes.totalMinutes <= 20){
            _10to20personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes >= 20 && a.dwellTimeMinutes.totalMinutes <= 30){
            _20to30personCount += a.personCount;
          }
          if(a.dwellTimeMinutes.totalMinutes > 30){
            _30pluspersonCount += a.personCount;
          }         
        });
        this.pageData.cHisDTRangeData.push(_3to5personCount);
        this.pageData.cHisDTRangeData.push(_5to10personCount);
        this.pageData.cHisDTRangeData.push(_10to20personCount);
        this.pageData.cHisDTRangeData.push(_20to30personCount);
        this.pageData.cHisDTRangeData.push(_30pluspersonCount);
      }
      //this.chartDwellTimeBind();
    }
    })
  }

  dataExportCsv() {
    var _nl = '\r\n';
    var csv = 'FROM DATE RANGE '+_moment(this.selectedMoment[0]).format('D/MM/YYYY') + ' - '+ _moment(this.selectedMoment[1]).format('D/MM/YYYY')+ ' TO DATE RANGE '+_moment(this.compareSelectedMoment[0]).format('D/MM/YYYY') + ' - '+ _moment(this.compareSelectedMoment[1]).format('D/MM/YYYY') +',';
    csv += "Day" + ',';
    csv += "Traffic" + ',';
    csv += "Compare Day" + ',';
    csv += "Compare Traffic" + ',';
    // csv += "Occupancy" + ',';
    // csv += "Avg Dwell Time" + ',';
    csv += _nl;
    this.exportData.forEach(s => {
      csv += _nl + ',' + s.d.toString() + ','+`${s.t},`+ s.hd.toString() + ','+`${s.ht},`;
    });
    var blob = new Blob([csv], {type: 'text/csv' })
    saveAs(blob, "exportData.csv");

  }

  public updateOptions() {
    this.salesChart.data.datasets[0].data = this.data;
    this.salesChart.update();
  }

  chartOrdersBind(dataLabel: any){
    var _pluginsLegendTooltip:any = {
      legend: { display:false },
          tooltip: { mode: 'index', intersect: false }
    };
    
    const bgColor = {
      id: 'bgColor',
      beforeDraw: (chart, options) => {
        const { ctx, width, height } = chart;
        ctx.fillStyle = 'white';
        ctx.fillRect(0,0,width,height);
        ctx.restore();
      }
    }
    
    var _borderColorH = "rgba(224,224,224,0.5)", _bgColorH = 'rgba(31,41,21,0.3)'; //'rgba(117,117,117,0.1)';
    var _lblToday = 'Today', _lblLastWeek = 'Last Week', _borderHDash = [5,5];
    var _pointBorderColorH = "rgba(224,224,224,1)";
    
    const chartOrders =  this.chtOrders.nativeElement.getContext('2d'); //document.getElementById('chart-orders');
    if(this.ordersChart != null) this.ordersChart.destroy();
    this.ordersChart = new Chart(chartOrders, {
      type: 'line',
      // options: {
      //   plugins: _pluginsLegendTooltip,
      //   maintainAspectRatio: false,
      //   scales: {
      //   },
      // },
      plugins: [bgColor],
      data: {
        labels: this.dailyLabels,
        datasets: [
          {
            data: this.dailyCounts, label: "Traffic", fill: true, tension: 0.5, 
            backgroundColor: "rgba(33,150,243,0.2)", borderColor: "#90caf9", pointBorderColor: '#90caf9'
          },
          {
            data: this.hisDailyCounts,label: "Last Traffic", fill: true, tension: 0.5, borderDash: _borderHDash,
            backgroundColor : _bgColorH, borderColor: _borderColorH, pointBorderColor: _pointBorderColorH
          }
        ]
      },
      options:{
        plugins:{
         tooltip: {
           mode: 'index', 
           intersect: false,
           callbacks:{
           label(this, tooltipItem) {
             if(tooltipItem.datasetIndex == 0)return dataLabel[tooltipItem.dataIndex].d +': '+dataLabel[tooltipItem.dataIndex].t;
             if(tooltipItem.datasetIndex == 1)return dataLabel[tooltipItem.dataIndex].hd +': '+dataLabel[tooltipItem.dataIndex].ht;
           }
          }
         }
        },       
       maintainAspectRatio: false
     }
    });
  }

  chartTopEntrancesBind(cTopSensorData: any){

    const bgColor = {
      id: 'bgColor',
      beforeDraw: (chart, options) => {
        const { ctx, width, height } = chart;
        ctx.fillStyle = 'white';
        ctx.fillRect(0,0,width,height);
        ctx.restore();
      }
    }

    const chartTe = this.chtTe.nativeElement.getContext('2d'); //document.getElementById('chart-sales');
    var canvas = document.getElementById('chtTe'); 
    // chartTe.canvas.parentNode.style.height = '700px';
    // chartTe.canvas.parentNode.style.width = '700px';
    if(this.teChart != null) this.teChart.destroy();
    this.teChart = new Chart(chartTe, {
      type: 'pie',
      options:
      {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
          legend:{
            position: 'right'
          }
        }
      },
      plugins: [bgColor],
      data: {
        labels: this.pageData.cSensorUuid,
        datasets: [
          {
            label: "Traffic",
            data: cTopSensorData,
            backgroundColor: '#d500f9',
            indexAxis: 'y',
          },
          {
            label: "Last Week ",
            data: this.pageData.cHisTopSensorData,
            backgroundColor: 'rgba(249, 231, 159 )', //'rgba(31,41,21,0.3)', //'rgba(211,211,211,0.2)',
            indexAxis: 'y',
          },
        ]
      },
    });
  }

  // chartDwellTimeBind(){
  //   const chartDt = this.chtDt.nativeElement.getContext('2d'); //document.getElementById('chart-sales');
  //   if(this.dtChart != null) this.dtChart.destroy();
  //   this.dtChart = new Chart(chartDt, {
  //     type: 'bar',
  //     options: //chartExample5.optionsBarHorizonal,
  //     {
  //       indexAxis: 'y',
  //     },
  //     data: {
  //       labels: ["(3-5) Min", "(5-10) Min", "(10-20) Min", "(20-30) Min", "(30+) Min"],
  //       datasets: [
  //         {
  //           label: "Traffic", //data: [5.2, 17.53, 12.11, 36.37, 28.79],
  //           data: this.pageData.cDTRangeData,//[5.2, 17.53, 12.11, 36.37, 28.79], 
  //           backgroundColor: '#d500f9',
  //           axis: 'y',
  //           //xAxisID: 'x-axis-2'
  //         },
  //         {
  //           label: "Last Week ", //data: [321, 99, 18, 5, 1],//[6.65, 14.44, 13.79, 41.33, 23.79],
  //           data: this.pageData.cHisDTRangeData,  //[6.65, 14.44, 13.79, 41.33, 23.79],
  //           backgroundColor: 'rgba(211,211,211,0.2)',
  //           axis: 'y',
  //           //xAxisID: 'x-axis-2'
  //         },
  //       ]
  //     },
  //   });
  // }

}

